import { render } from "./RoomService.vue?vue&type=template&id=6ced3be6"
import script from "./RoomService.vue?vue&type=script&lang=js"
export * from "./RoomService.vue?vue&type=script&lang=js"
script.render = render

export default script